import { useOidcStore } from "vue3-oidc";

// Skew before expiry (s) to avoid a token expiring mid-flight.
const EXPIRY_SKEW_SECONDS = 30;

// De-duplication: the search page can fire several requests in parallel;
// we only want a single signinSilent in flight at a time.
let refreshPromise = null;

// Returns a valid access token, refreshing it proactively.
// On a long-lived view without navigation (e.g. businesspartner search),
// the router guard never re-runs: without this refresh, requests would go out
// with a stale token once the background renew has failed.
export async function getFreshAccessToken() {
  const { state, actions } = useOidcStore();
  const sv = state.value;
  const expiresAt = sv.user?.expires_at; // epoch seconds
  const needsRefresh =
    expiresAt && Date.now() / 1000 > expiresAt - EXPIRY_SKEW_SECONDS;

  if (needsRefresh && sv.userManager) {
    refreshPromise ??= sv.userManager
      .signinSilent()
      .then((user) => {
        if (user) {
          actions.value.setUser(user);
        }
      })
      .catch((err) =>
        console.error("[auth] proactive token refresh failed:", err),
      )
      .finally(() => {
        refreshPromise = null;
      });
    await refreshPromise;
  }

  return state.value.token;
}
